<template>

    <ui-form-item v-bind="$componentProps('ui-form-item')" v-slot="{ errors }" :class="$attrs.class" :style="$attrs.style">

        <ui-input v-bind="inputBinds" v-model="innerValue" :error="errors" ref="input"></ui-input>

    </ui-form-item>

</template>

<script lang="ts">

import { Component, Model, Vue } from 'vue-facing-decorator';
import { omit } from 'lodash';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { FormItemProps } from './FormItem.vue';
import FormItem, { formItemCompMixin } from './FormItem.vue';

import type { InputProps } from '../control/Input.vue';
import Input, { inputCompMixin } from '../control/Input.vue';

@Component({
    name: 'ui-form-input',
    inheritAttrs: false,
    components: {
        'ui-form-item': FormItem,
        'ui-input': Input
    },
    mixins: [componentPropsMixin, formItemCompMixin, inputCompMixin]
})
export default class FormInput extends Vue {

    @Model({ type: [String, Number] })
    innerValue: string | number;

    get inputBinds(){

        return {
            ...this.$componentProps('ui-input', ['modelValue', 'error', 'onUpdate:modelValue']),
            ...omit(this.$attrs, ['class', 'style', 'modelValue', 'onUpdate:modelValue'])
        };
    }
}

export type FormInputComp = InstanceType<typeof FormInput>
export type FormInputProps = ComponentProps<FormInputComp> & FormItemProps & InputProps
export const formInputCompMixin = createComponentMixin(FormInput, formItemCompMixin, inputCompMixin)

</script>